import { plural } from './plural'

/** Strings for the command palette (S3, K2). */
export const paletteCopy = {
  label: 'Command palette',
  input: 'Jump to a topic, agent or person',
  groups: {
    topics: 'Topics',
    agents: 'Agents',
    people: 'People',
    actions: 'Actions',
  },
  actions: { newAgent: 'New agent', inviteMember: 'Invite member' },
  resultsLabel: 'Results',
  count: (n: number) => plural(n, { one: '{n} result', other: '{n} results' }),
  hints: { move: 'Move', open: 'Open', close: 'Close' },
  noMatches: (query: string) =>
    query ? `No matches for "${query}"` : 'No matches',
  loadFailed: 'Could not load topics, agents and people.',
} as const
